import { defineStore } from 'pinia';
import PublicService from '@/services/public.service';
import { useMainStore } from './mainStore';
import moment from 'moment';

export const useGroupeStore = defineStore('groupe', {
    state: () => ({
        default_fields: null,
        is_inscription_groupe: false,
        is_lien_groupe: false,
        token: null,
        max_inscrits: 0,
        nb_inscrits: 0,
        nb_commandes: 0,
        doit_payer: true,
        inscription_course_complete: false,
        doit_payer_options: true,
        inscriptions_options_completes: true,
        disable: false,
        limit_acces_parcours: false,
        filter_parcours: "",
        date_expiration: null,
        type_paiement: null,
    }),
    actions: {
        async fetchGroupeInfos(token_groupe, id_module) {
            const mainStore = useMainStore();

            let res = await PublicService.getGroupeInfos(token_groupe, id_module);
            if (res) {
                if (res.disable == '1') {
                    this.disable = true;
                    mainStore.notification.send("Ce lien d'inscription de groupe a été désactivé par l'organisateur. Vous ne pouvez plus vous inscrire à ce groupe.", "error", 10000);
                    this.clearState();
                    return;
                }
                if (res.date_expiration && res.date_expiration != '0000-00-00') {
                    if (moment(res.date_expiration).endOf('day').isBefore(moment())) {
                        mainStore.notification.send("Ce lien d'inscription de groupe a expiré le " + moment(res.date_expiration).format("DD/MM/YYYY"), "error", 10000);
                        this.clearState();
                        return;
                    }
                }
                if (res.max_inscrits && res.max_inscrits != '0') {
                    const max_inscrits = parseInt(res.max_inscrits);
                    const nb_inscrits = res.nb_inscrits ? parseInt(res.nb_inscrits) : 0;
                    if (nb_inscrits >= max_inscrits) {
                        mainStore.notification.send("Ce lien d'inscription de groupe a atteint la limite d'inscriptions.", "error", 10000);
                        this.clearState();
                        return;
                    }
                }
                this.default_fields = {
                    club: res.nom,
                    mail: "",
                    telephone: "",
                    cp: "",
                    ville: "",
                    contact_urgence: "",
                    tel_contact_urgence: "",
                };
                this.is_inscription_groupe = true;
                this.is_lien_groupe = true;
                this.token = token_groupe;
                this.max_inscrits = res.max_inscrits;
                this.nb_inscrits = res.nb_inscrits;
                this.nb_commandes = res.nb_commandes;
                this.doit_payer = res.doit_payer == '0' ? false : true;
                this.inscription_course_complete = res.inscription_course_complete == '0' ? false : true;
                this.doit_payer_options = res.doit_payer_options == '0' ? false : true;
                this.inscriptions_options_completes = res.inscriptions_options_completes == '0' ? false : true;
                this.limit_acces_parcours = res.limit_acces_parcours == '1' || res.limit_acces_parcours === true;
                this.filter_parcours = res.filter_parcours || "";
                this.date_expiration = res.date_expiration || null;
                this.type_paiement = res.type_paiement || null;
                this.commitToLocalStorage();

            }
        },
        clearState() {
            this.default_fields = null;
            this.is_inscription_groupe = false;
            this.is_lien_groupe = false;
            this.token = null;
            this.max_inscrits = 0;
            this.nb_inscrits = 0;
            this.nb_commandes = 0;
            this.doit_payer = true;
            this.inscription_course_complete = false;
            this.doit_payer_options = true;
            this.inscriptions_options_completes = true;
            this.limit_acces_parcours = false;
            this.filter_parcours = "";
            this.date_expiration = null;
            this.type_paiement = null;
            this.clearLocalStorage();
        },
        async initializeFromLocalStorage() {
            this.clearLocalStorageFromOtherModules();
            const mainStore = useMainStore();

            const id_item = "sportips_groupe_" + mainStore.module.base;
            const id_expires_item = "sportips_groupe_expires_" + mainStore.module.base;
            if (localStorage.getItem(id_item)) {
                if (localStorage.getItem(id_expires_item) && moment().isBefore(localStorage.getItem(id_expires_item))) {
                    let local_groupe = JSON.parse(localStorage.getItem(id_item));
                    await this.setGroupeFromLocalStorage(local_groupe, mainStore.module.id);
                }
            }
        },
        async setGroupeFromLocalStorage(local_groupe, id_module) {

            this.token = local_groupe.token;
            await this.fetchGroupeInfos(this.token, id_module);

        },
        clearLocalStorageFromOtherModules() {
            const mainStore = useMainStore();
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key.includes(mainStore.module.base)) {
                    continue;
                }
                if (key.includes("sportips_groupe_") || key.includes("sportips_groupe_expires_")) {
                    localStorage.removeItem(key);
                }
            }
        },
        commitToLocalStorage() {
            const mainStore = useMainStore();
            const id_item = "sportips_groupe_" + mainStore.module.base;
            const id_expires_item = "sportips_groupe_expires_" + mainStore.module.base;
            localStorage.setItem(id_item, JSON.stringify(this.$state));
            localStorage.setItem(id_expires_item, moment().add(1, 'hour').format());


        },
        clearLocalStorage() {
            const mainStore = useMainStore();
            const id_item = "sportips_groupe_" + mainStore.module.base;
            const id_expires_item = "sportips_groupe_expires_" + mainStore.module.base;
            localStorage.removeItem(id_item);
            localStorage.removeItem(id_expires_item);
        },
    },
    getters: {

        get_status() {

            const text_inscription_course_complete = this.inscription_course_complete ? " Vous pourrez vous inscrire aux courses complètes." : "";
            if (this.max_inscrits == 0) {
                return "Ce lien d'inscription de groupe est valide. Il n'y a pas de limite sur le nombre d'inscriptions.";
            }
            if (this.nb_inscrits >= this.max_inscrits) {
                return "Malheureusement ce lien d'inscription de groupe n'est plus valide, il a atteint la limite d'inscriptions.";
            }
            return "Ce lien d'inscription de groupe est valide. Il vous reste " + (this.max_inscrits - this.nb_inscrits) + " inscription(s) disponible(s)." + text_inscription_course_complete;
        }
    }
});